import React from 'react'
import "./color.css"

function OrangeUL() {
    var x = localStorage.getItem("percentage ulp")

    return (
        <div className = "orange__backgroundul">
            {x == "NaN" ? "null": x} %
        </div>
    )
}

export default OrangeUL
